export enum UnitOfMeasurement {
  KILOMETERS = "км",
  METERS = "м",
  GRAMS = "гр",
  KILOGRAMS = "кг",
  LITERS = "л",
  PIECES = "шт",
  SQUARE_METERS = "кв.м",
  CUBIC_METERS = "куб.м",
  BLOCK = "блок"
}
